import React, { useEffect, useRef, useState } from 'react';
import { FileUploaderWidgetLayoutProps } from '../types';
import { ValidationError } from 'request-sender';
import { useFileService } from 'nekst-api';
import { SimpleBlock } from 'ui-builder';

export default function FileUploaderWidgetLayoutWeb(
  props: FileUploaderWidgetLayoutProps,
) {
  const [progress, setProgress] = useState<number>();

  useEffect(() => {
    if (progress === 100) {
      setTimeout(() => setProgress(undefined), 1000);
    }
  }, [progress]);

  const ref = useRef<HTMLInputElement>(null);

  const fileService = useFileService();

  const handleFileChosen = async (e: any) => {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;

    if (file) {
      try {
        props.onUploaderStart?.();

        const result = await fileService.uploadFile(
          file,
          props.fileType,
          file.name,
          setProgress,
          props.asAdmin,
        );

        props.onFileUploaded(result);
      } catch (error: any) {
        if (error instanceof ValidationError) {
          props.onValidationErrors(error.errors);
        }
        ref.current!.value = '';
      } finally {
        props.onFinished?.();
      }
    }
  };

  return (
    <>
      <input
        ref={ref}
        type="file"
        name={props.name}
        onChange={handleFileChosen}
        style={{ display: props.widget ? 'none' : undefined }}
      />
      {props.widget && <props.widget onClick={() => ref.current?.click()} />}
      {progress && progress < 100 && (
        <SimpleBlock className="upload-progress">
          {`Uploading... ${progress}%`}
        </SimpleBlock>
      )}
      {progress === 100 && (
        <SimpleBlock className="upload-progress">
          File Uploaded
        </SimpleBlock>
      )}
    </>

  );
}
